import { createFileRoute, Link, useRouter } from '@tanstack/react-router';
import { ArrowLeft, MonitorPlay, ShieldAlert } from 'lucide-react';
import { PermissionGate } from '@/components/PermissionGate';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { RemoteAccessViewer } from '@/features/remote-access/components/RemoteAccessViewer';
import { REMOTE_CONTROL_PERMISSION } from '@/features/assets/components/RemoteActionsMenu';

export const Route = createFileRoute('/_authenticated/remote-access/$deviceId')({
  component: RemoteAccessPage,
});

function AccessDenied() {
  return (
    <Card>
      <CardContent className="flex flex-col items-center gap-3 py-12 text-center">
        <ShieldAlert className="h-10 w-10 text-red-500" />
        <h2 className="text-lg font-semibold">Acesso negado</h2>
        <p className="text-sm text-muted-foreground">
          Você não tem permissão de acesso remoto aos PCs (assets.remote_control). Peça a um
          administrador.
        </p>
      </CardContent>
    </Card>
  );
}

function RemoteAccessPage() {
  const { deviceId } = Route.useParams();
  const router = useRouter();
  const goBack = () => router.history.back();

  return (
    <div className="flex h-full flex-col gap-4 py-4">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="sm" asChild>
          <Link to="/realtime">
            <ArrowLeft className="mr-1 h-4 w-4" />
            Realtime
          </Link>
        </Button>
        <h1 className="flex items-center gap-2 text-2xl font-bold">
          <MonitorPlay className="h-6 w-6" />
          Acesso remoto
        </h1>
      </div>
      <PermissionGate permission={REMOTE_CONTROL_PERMISSION} fallback={<AccessDenied />}>
        <RemoteAccessViewer deviceId={deviceId} onExit={goBack} />
      </PermissionGate>
    </div>
  );
}
